/**
 * UserRelationData 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { UserData } from './user_data'
import type { UserRelation } from './user_relation'

/**
 * UserRelationData
 */
export interface UserRelationData {
  /** 关系ID */
  id?: string
  /** 关系基础信息 */
  relation?: UserRelation
  /** 发起方用户信息 */
  src_user?: UserData
  /** 目标方用户信息 */
  dst_user?: UserData
}

/**
 * UserRelationData Schema
 */
export const UserRelationDataSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '关系ID',
      format: 'string',
      type: 'string',
      label: '关系ID',
    },
    relation: {
      $ref: 'UserRelation',
      description: '关系基础信息',
      label: '关系基础信息',
    },
    src_user: {
      $ref: 'UserData',
      description: '发起方用户信息',
      label: '发起方用户信息',
    },
    dst_user: {
      $ref: 'UserData',
      description: '目标方用户信息',
      label: '目标方用户信息',
    },
  },
  type: 'object',
}
